const MAX_RECIPIENTS = 10_000;

export const parseRecipientIds = (input: string): string[] =>
  Array.from(
    new Set(
      input
        .split(/[\s,;]+/)
        .map((value) => value.trim())
        .filter(Boolean)
    )
  ).slice(0, MAX_RECIPIENTS);

export const MAX_ADMIN_EMAIL_RECIPIENTS = MAX_RECIPIENTS;
